import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Root';

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root'),
);
